import { useState } from "react";
import {auth,db} from '.././dashboard/firebase/firebase';
import {addDoc, collection,getDocs,query} from 'firebase/firestore';
import {useNavigate} from 'react-router-dom'
import queryString from 'query-string';
import { de_encrypt } from "../../encryption";
const Ads = () => {
    const navigate = useNavigate();
    const _url= queryString.parse(window.location.search);
    const admin =['owoadeanuoluwapo2@gmail.com','ogbonnaemmanuel494@gmail.com','Psalmsheg@gmail.com','aowoade749@stu.ui.edu.ng'];
    const [lin,setLin]=useState(false);
    if(_url.admin != undefined){
       if(!(admin.includes(de_encrypt(_url.admin)))){
         navigate('/admin');
        }
    }else{
      navigate('/admin');
     }
    const tabs = ["All","Products","Forex", "WebDesign","GraphicDesign","Cryptocurrency"]
    const [url,setUrl]=useState("");
    const [name,setName]=useState("");
    const [category,setCategory]=useState("");
    const [endLink,setEndLink]=useState("");
    const [caption,setCaption]=useState("")
    const addAds = async (e)=>{
        e.preventDefault()
        const ad_data={
            time:Date.now(),
            creator:name,
            category,
            engagements:[],
            image:url,
            link:endLink,
            caption
        }
        const docRef = await addDoc(collection(db, "ads"), ad_data);
        setUrl("");
        setName("");
        alert("ad posted")
    }
    return (
        <main>
            <form onSubmit={(e)=>addAds(e)}>
                <input type="text" value={name} placeholder="Enter Creator's name" required onChange={(e)=> setName(e.target.value)}/>
                <input type="text" value={url} placeholder="Enter Image link"  onChange={(e)=> setUrl(e.target.value)} required />
                <select onChange={(e) => { setCategory(e.target.value) }} required>
                    <option value="null">Select package</option>
                    <option value="Forex">Forex</option>
                    <option value="Products">Products</option>
                    <option value="WebDesign">WebDesign</option>
                    <option value="GraphicDesign">GraphicDesign</option>
                    <option value="Cryptocurrency">Cryptocurrency</option>
                    <option value="Others">Others</option>
                </select>
                <input type="text" value={endLink} placeholder="attach affiliate link"  onChange={(e)=> setEndLink(e.target.value)} required />
                <input type="text" value={caption} placeholder="Enter caption"  onChange={(e)=> setCaption(e.target.value)} required />
                <button type="submit">Submit</button>
            </form>
        </main>
    );
}

export default Ads;